import i18n from '@speechki-frontend/core/i18n/i18n';
import { PlansPage } from './views';

const routes = [
    {
        path: '/plans',
        name: 'plans',
        component: PlansPage,
        meta: {
            guest: true,
            title: i18n.global.t('payment.plans.title'),
        },
    },
];

export default routes;
